import { combineReducers } from "redux"
import { createIsLoadedReducer } from "reducers/shared"
import actionTypes from "actions/actionTypes"
import ActionTypes from "actions/actionTypes"
import { IPageSet } from "contentful-types"

const reducers = {
  isLoaded: createIsLoadedReducer(ActionTypes.FETCH_PAGE_SETS),

  pageSets: (state = null, action) => {
    switch (action.type) {
      case actionTypes.FETCH_PAGE_SETS_SUCCESS:
        return action.response
      default:
        return state
    }
  }
}

const pageSets = combineReducers(reducers)

type PageSetsType = {
  items: IPageSet[]
}
export const getPageSets = (state): PageSetsType => state.pageSets.pageSets
export const getPageSetsAreLoaded = (state) => state.pageSets.isLoaded

export default pageSets
